import script from "./transportContractReview.vue?vue&type=script&setup=true&lang=js"
export * from "./transportContractReview.vue?vue&type=script&setup=true&lang=js"

import "./transportContractReview.vue?vue&type=style&index=0&id=7617b7c6&lang=less"

const __exports__ = script;

export default __exports__